import { Component, OnInit } from '@angular/core';
import {DiamondPayDataService} from "../diamond-pay-data-service.service";

@Component({
  selector: 'app-unmatched-transactions',
  templateUrl: './unmatched-transactions.component.html',
  styleUrls: ['./unmatched-transactions.component.css'],
  providers: [DiamondPayDataService],
})
export class UnmatchedTransactionsComponent implements OnInit {
  private collection: any[];

  constructor(private _dataService: DiamondPayDataService) { }


  ngOnInit() {
    this._dataService
            .RetrieveUnmatchedTransactions()
            .subscribe((data:any[]) => this.collection = data, error => console.log(error));
  }

}



// WEBPACK FOOTER //
// ./src/app/unmatched-transactions/unmatched-transactions.component.ts